module.exports = __webpack_public_path__ + "img/side-crash.14256075.svg";